export default {
  name: 'greatboss',
  env: "prodGreatboss",
  baseURL: `https://www.greatboss.com`,
  wxMpRegisterUrlBase: `https://m.greatboss.com`,
};
